var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"top-info"},[_c('group-nav',{attrs:{"group":_vm.group}}),_c('group-last-update',{attrs:{"lastUpdate":_vm.lastUpdate}})],1),_c('group-header',{attrs:{"group":_vm.group}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }